import { Component, Prop, h, Host, Listen, Element, State } from '@stencil/core';
import { translations } from './translations';
import { SideMenui18n } from './types';
import state from './pn-sidenav-store';

@Component({
  tag: 'pn-sidenav',
  styleUrl: 'pn-sidenav.scss',
  shadow: false,
})
export class PnSidenav {
  @Element() hostElement: HTMLElement;
  /** Specifies which language we want to show navigation in (sv,da,fi,no,en) */
  @Prop() language: string = 'sv';
  /** Sets the label of the navigation (Required if multiple nav elements are on a page) */
  @Prop() navLabel: string = '';

  @State() i18n: SideMenui18n = { open: '', close: '', navLabel: '' };

  componentWillLoad() {
    this.init();
  }

  async init() {
    this.setLanguage();
    if (window.matchMedia('screen and (min-width:64em)').matches === false) {
      state.openMenu = false;
    }
  }

  @Listen('language')
  setLanguage() {
    if (translations[this.language]) {
      state.i18n = translations[this.language] as SideMenui18n;
      
      if (!this.navLabel) {
        this.navLabel = state.i18n.navLabel;
      }
    }
  }

  @Listen('openSubMenuLevelChange')
  onOpenSubMenuLevelChange(event) {
    state.openLevel = event.detail;
  }

  render() {
    return (
      <Host open={(state.openMenu == true) + ''}>
        <slot name="above"></slot>
        <nav class="sidenav" aria-label={this.navLabel}>
          <slot></slot>
        </nav>
      </Host>
    );
  }
}
